/** Só o admin lista todos os deals e usa o filtro por closer. */
export function canFilterDealsByCloser(role?: string | null): boolean {
  if (!role) return false
  return role.toUpperCase() === 'ADMIN'
}
